import { useSEO } from "@/lib/seo";
import Hero from "@/components/sections/Hero";
import AboutPreview from "@/components/sections/AboutPreview";
import Specialities from "@/components/sections/Specialities";
import Techniques from "@/components/sections/Techniques";
import Brachytherapy from "@/components/sections/Brachytherapy";
import PatientJourney from "@/components/sections/PatientJourney";
import WhyChoose from "@/components/sections/WhyChoose";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import { INTRO } from "@/lib/site";
import { Link } from "react-router-dom";

export default function HomePage() {
  useSEO({
    title: "Radiation Oncologist in Hyderabad",
    description:
      "Consult Dr. Anusha Mandava, Radiation Oncologist in Hyderabad with 10 years of clinical experience. Expertise in breast, gynecological, head & neck, lung, pediatric, neuro, GI and GU cancers.",
    keywords:
      "Radiation Oncologist in Hyderabad, Cancer Specialist Hyderabad, Breast Cancer Radiation Therapy, Brachytherapy Specialist Hyderabad, IMRT VMAT IGRT",
    path: "/",
  });

  return (
    <div data-testid="home-page">
      <Hero />

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
            Comprehensive Care
          </div>
          <h2 className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900">
            {INTRO.heading}
          </h2>
          {INTRO.paragraphs.map((p, i) => (
            <p key={i} className="mt-5 text-slate-600 leading-relaxed">
              {p}
            </p>
          ))}
          <Link
            to="/contact"
            data-testid="intro-cta"
            className="mt-8 inline-flex items-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-blue-800 transition-colors"
          >
            Speak to a Specialist →
          </Link>
        </div>
      </section>

      <AboutPreview />
      <Specialities />
      <Techniques />
      <Brachytherapy />
      <PatientJourney />
      <WhyChoose />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
